import { useState } from 'react';

export type ActiveEditor = 'none' | 'tenant' | 'location';

export type FeatureSubscriptionsEditing = {
  activeEditor: ActiveEditor;
  setActiveEditor: (editor: ActiveEditor) => void;
};

const useFeatureSubscriptionsEditing = (): FeatureSubscriptionsEditing => {
  const [activeEditor, setActiveEditor] = useState<ActiveEditor>('none');

  return {
    activeEditor,
    setActiveEditor,
  };
};

export default useFeatureSubscriptionsEditing;
